import React, { useEffect, useState, useRef } from "react";
import { BsPlusLg, BsTrash, BsPencilSquare, BsCheck2All } from "react-icons/bs";

import {
  AiOutlineInfoCircle,
  AiFillDelete,
  AiOutlinePlus,
  AiOutlineMinus,
} from "react-icons/ai";
import $ from "jquery";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { propertyService } from "../../../_services";
import { validateRoom, validateSleepingArrangements } from "../validators/validateSleepingArrangements";
import { CustomHorizontalScrollbar } from "../components/CustomHorizontalScrollBar";

export const SleepingArrangements = ({
  onNext,
  onPrev,
  formData,
  setFormData,
  className,
  save,
  updating,
}) => {
  const [roomList, setRoomList] = useState(
    formData["sleepingArrangements"] || []
  );
  const [stepForm, setStepForm] = useState({});
  const [beds, setBeds] = useState([]);

  const [bedNumber, setBedNumber] = useState("");
  const [perNightPrice, setNightPrice] = useState("");
  const [perMonthPrice, setMonthPrice] = useState("");
  const [bedType, setBedType] = useState("");

  const [isEdit, setEdit] = useState(false);

  const [index, setIndex] = useState(0);

  const [numberOfBathroom, setBathroom] = useState(0);

  const valueRef = useRef(formData);
  const elementRef = useRef(null);
  const scrollbarRef = useRef(null);

  const isHidden = () => {
    if(!elementRef.current) {
      return true
    }
    return elementRef.current?.classList.contains("tw-hidden")
  }
  
  useEffect(() => {
    valueRef.current = {...formData}
  }, [formData])
  
  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    
    const observer = new MutationObserver(() => {
      if (element.classList.contains('tw-hidden')) {
        handleComponentDisappear();
      }
    });
    
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    return () => observer.disconnect();
  }, []);

  const handleComponentDisappear = () => {
    setFormData(valueRef.current);
  };

  const emptyProperty = () => {
    let obj = {
      bedNumber: '',
      bedType: ''
    }

    if (
      formData.rentalType === "Crashpad" &&
      (formData.bookingType === "Hot bed" ||
        formData.bookingType === "Flexible")
    ) {
      obj = {
        ...obj,
        perNightPrice: ''
      }
    }

    if (
      formData.rentalType === "Crashpad" &&
      (formData.bookingType === "Cold bed" ||
        formData.bookingType === "Flexible")
    ) {
      obj = {
        ...obj,
        perMonthPrice: ''
      };
    }

    return obj
  }

  const handleBed = (ind) => {
    let actualBedNumber = bedNumber
    let actualPerNightPrice = perNightPrice
    let actualPerMonthPrice = perMonthPrice
    let actualBedType = bedType

    if(ind != undefined) {
      const bed = beds[ind]
      actualBedNumber = bed.bedNumber
      actualPerNightPrice = bed.perNightPrice
      actualPerMonthPrice = bed.perMonthPrice
      actualBedType = bed.bedType
    }


    if (!stepForm.numberOfBeds) return;
    if (beds.length == stepForm.numberOfBeds) return;

    var setObj = { bedNumber: actualBedNumber, bedType: actualBedType };
    if (formData.rentalType === "Crashpad") {
      if (!actualBedNumber) return;
      if (beds.length) {
        if (beds.some((bed, i) => bed.bedNumber === actualBedNumber && (ind != undefined ? i != ind : true))) {
          toast.info("Bed number must be unique.");
          return;
        }
      }
    }
    if (actualPerNightPrice) setObj["perNightPrice"] = actualPerNightPrice;
    if (actualPerMonthPrice) setObj["perMonthPrice"] = actualPerMonthPrice;

    if (
      formData.rentalType === "Crashpad" &&
      (formData.bookingType === "Hot bed" ||
        formData.bookingType === "Flexible") &&
      !actualPerNightPrice
    ) {
      return;
    }

    if (
      formData.rentalType === "Crashpad" &&
      (formData.bookingType === "Cold bed" ||
        formData.bookingType === "Flexible") &&
      !actualPerMonthPrice
    ) {
      return;
    }

    if (!actualBedType) {
      return;
    }

    let newBeds = []
    if(ind != undefined) {
      beds.forEach((bed, i) => {
        if(i == ind) {
          newBeds.push(setObj)
        } else {
          newBeds.push(bed)
        }
      })
    } else {
      newBeds = [...beds, setObj]
      setBedNumber("");
      setBedType("");
      setNightPrice("");
      setMonthPrice("");
    }

    if(stepForm.numberOfBeds && newBeds.length <= stepForm.numberOfBeds - 1) {
      newBeds = [...newBeds, emptyProperty()]
    }
    const container = document.querySelector('.bedTable');
    container.classList.add('overflowXHide');
    setBeds(newBeds);
    requestAnimationFrame(() => {
      container.classList.remove('overflowXHide');
      setTimeout(() => {
          container.style.overflow = 'hidden';
          container.offsetHeight;
          container.style.overflow = 'auto';
          container.scrollLeft = container.scrollLeft;
      }, 10);
    });

  };

  //   const removeBed = (index) => {
  //     var b = beds.filter((value, idx) => idx != index);
  //     setBeds(b);
  //   };
  const removeBed = (indx) => {
    var b = beds.filter((value, idx) => idx != indx);
    console.log(roomList);
    try {
      roomList.map((room, i) => {
        if (index === i) {
          room.beds = b;
        }
      });
      setRoomList([...roomList]);
    } catch (error) {
      console.log(error, "error removing bed");
    }
    if(b.length == 0 && stepForm.length > 0) {
      setBeds(emptyProperty)
    } else {
      setBeds(b);
    }
  };

  const handleRoom = (e) => {
    e.preventDefault();
    if (beds.length == 0) return;
    // if (numberOfBathroom == 0) return;
    if (beds.length != stepForm.numberOfBeds) {
      toast.info("Number of beds and added beds must be same.");
      return;
    }
    if (
      stepForm["roomType"] === "Shared" &&
      parseInt(stepForm["numberOfBeds"]) === 1
    ) {
      toast.info("Number of beds must be greater than 1 for shared rooms.");
      return;
    }
    if (formData.rentalType === "Crashpad" && !validateCrashpadRoomBeds(beds)) {
      toast.info("Please fill beds property");
      return;
    }

    function validateCrashpadRoomBeds(beds = []) {
      return (
        beds.filter((bed) => bed.bedNumber.trim().length === 0).length === 0
      );
    }
    const result = validateRoom({
      ...stepForm,
      numberOfBathroom: numberOfBathroom,
      beds,
    }, index, formData.rentalType, formData.bookingType)
    if(!result.isValid) {
      if(result.errors.length > 0) {
        toast.info(result.errors[0].error, { toastId: "bed" });
      }
      return
    }
    if (isEdit) {
      var updatedRoomList = [];
      roomList.forEach((room, idx) => {
        if (idx == index)
          updatedRoomList.push({
            ...stepForm,
            numberOfBathroom: numberOfBathroom,
            beds,
          });
        else updatedRoomList.push(room);
      });
      setRoomList(updatedRoomList);
      valueRef.current = {
        ...formData,
        sleepingArrangements: updatedRoomList,
      };
    } else {
      const newIndex = roomList.length
      setRoomList([
        ...roomList,
        { ...stepForm, numberOfBathroom: numberOfBathroom, beds },
      ]);
      valueRef.current = {
        ...formData,
        sleepingArrangements: [
          ...roomList,
          { ...stepForm, numberOfBathroom: numberOfBathroom, beds },
        ],
      };
      const result = validateRoom({ ...stepForm, numberOfBathroom: numberOfBathroom, beds }, newIndex, formData.rentalType, formData.bookingType)
      if(!result.isValid) {
        if(result.errors.length > 0) {
          toast.info(result.errors[0].error, { toastId: "bed" });
        }
        return
      }
    }
    if(scrollbarRef && scrollbarRef.current) {
      scrollbarRef.current?.scrollToStart();
    }
    const element =  document.querySelector('.mobile-nav')
    if(element) {
      const elementRect = element.getBoundingClientRect();
      const elementBottom = elementRect.bottom + window.scrollY;
  
      window.scrollTo({
        top: elementBottom,
        behavior: 'smooth'
      });
    }
    setBeds([]);
    setBedNumber("");
    setBedType("");
    setNightPrice("");
    setMonthPrice("");
    setStepForm({});
    document.body.classList.remove("modal-open");
    window.$("#addRoomModal").modal("hide");
    window.$(".modal-backdrop").remove();
  };

  const editSleepingArrangement = (room, index) => {
    isInitialBedRender.current = true
    setEdit(true);
    setIndex(index);
    var cloneRoom = Object.assign({}, room);
    setBeds(cloneRoom.beds);
    delete cloneRoom.beds;
    setStepForm(cloneRoom);
    setBathroom(cloneRoom.numberOfBathroom);
    window.$("#addRoomModal").modal("show");
  };

  const deleteSleepingArrangement = async (room, index) => {
    try {
      const result = await propertyService.isRoomDeletableService(room._id);
      if (result.data && result.data.isDeletable) {
        if(room._id) {
          const updatedRoomList = roomList.filter(
            (item) => item._id !== room._id
          );
          setRoomList(updatedRoomList);
        } else {
          if(index >= 0 && index < roomList.length) {
            let updatedRoomList = [...roomList]
            updatedRoomList.splice(index, 1)
            setRoomList(updatedRoomList);
          }
        }
      } else {
        toast.warn("Booking exists for this room, Deletion is not permitted");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const addSleepingArrangement = () => {
    setEdit(false);
    setBeds([]);
    setStepForm({});
    setBathroom(0);
    window.$("#addRoomModal").modal("show");
  };

  const isInitialBedRender = useRef(true);
  const renderBedlist = () => {
    const inputRefs = useRef([]);

    const prevBedsLength = useRef(beds.length);
    

    useEffect(() => {
        if (!isInitialBedRender.current && beds.length > prevBedsLength.current && prevBedsLength.current != 0) {
            const lastInputIndex = beds.length - 1;
            if (inputRefs.current[lastInputIndex]) {
                inputRefs.current[lastInputIndex].focus();
            }
        }
        prevBedsLength.current = beds.length;
        isInitialBedRender.current = false;
    }, [beds.length]);

    return beds.map((curr, ind) => {
        return (
          <tr key={ind}>
            {formData.rentalType === "Crashpad" && (
              <th style={{paddingTop: '20px', paddingBottom: '20px', paddingLeft: "6px", paddingRight: '6px'}}>
                <div>
                  <input
                    ref={el => inputRefs.current[ind] = el}
                    onChange={(e) => {
                      if (curr.bedNumber.trim().length > 0) {
                        setBeds(prevItems => {
                          const newItems = [...prevItems]; 
                          newItems[ind] = {...newItems[ind], bedNumber: e.target.value}; 
                          return newItems;
                        });
                      } else {
                        setBeds(prevItems => {
                          const newItems = [...prevItems]; 
                          newItems[ind] = {...newItems[ind], bedNumber: e.target.value.trim()}; 
                          return newItems;
                        });
                      }
                    }}
                    value={curr.bedNumber}
                    type="text"
                    className="form-control"
                    placeholder="Bed Number"
                    required
                  />
                </div>
              </th>
            )}
            <th style={{paddingTop: '20px', paddingBottom: '20px', paddingBottom: '20px', paddingLeft: "6px", paddingRight: '6px'}}>
              <div>
                <select
                  name="bed_type"
                  onChange={(e) => {
                    setBeds(prevItems => {
                      const newItems = [...prevItems]; 
                      newItems[ind] = {...newItems[ind], bedType: e.target.value}; 
                      return newItems;
                    });
                  }}
                  value={curr.bedType}
                  className="form-control wide"
                  style={{minWidth: '7rem', paddingLeft: '10px', paddingRight: '10px'}}
                  required
                >
                  <option value="">Select</option>
                  <option value="King">King</option>
                  <option value="Queen">Queen</option>
                  <option value="Twin">Twin</option>
                  <option value="Couch">Couch</option>
                  <option value="Top bunk">Top bunk</option>
                  <option value="Bottom bunk">Bottom bunk</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </th>

            {formData.rentalType === "Crashpad" &&
              (formData.bookingType === "Hot bed" ||
                formData.bookingType === "Flexible") && (
                <th style={{paddingTop: '20px', paddingBottom: '20px', paddingBottom: '20px', paddingLeft: "6px", paddingRight: '6px'}}>
                  <div>
                    <input
                      onChange={(e) => {
                        if (
                          parseInt(e.target.value) >= 1 ||
                          e.target.value == ""
                        ) {
                          setBeds(prevItems => {
                            const newItems = [...prevItems]; 
                            newItems[ind] = {...newItems[ind], perNightPrice: e.target.value
                              ? Math.floor(parseInt(e.target.value))
                              : ""}; 
                            return newItems;
                          });
                        }
                      }}
                      value={curr.perNightPrice}
                      placeholder="Per night price"
                      maxLength={9}
                      min={1}
                      max={999999999}
                      className="form-control"
                      type="text"
                      required
                    />
                  </div>
                </th>
              )}
            {formData.rentalType === "Crashpad" &&
              (formData.bookingType === "Cold bed" ||
                formData.bookingType === "Flexible") && (
                <th style={{paddingTop: '20px', paddingBottom: '20px', paddingBottom: '20px', paddingLeft: "6px", paddingRight: '6px'}}>
                  <div>
                    <input
                      onChange={(e) => {
                        if (
                          parseInt(e.target.value) >= 1 ||
                          e.target.value == ""
                        ) {
                          setBeds(prevItems => {
                            const newItems = [...prevItems]; 
                            newItems[ind] = {...newItems[ind], perMonthPrice: e.target.value
                              ? Math.floor(parseInt(e.target.value))
                              : ""}; 
                            return newItems;
                          });
                        }
                      }}
                      value={curr.perMonthPrice}
                      type="number"
                      className="form-control"
                      placeholder="Per month price"
                      maxLength={9}
                      min={1}
                      max={999999999}
                      required
                    />
                  </div>
                </th>
              )}

            {stepForm.numberOfBeds && (stepForm.numberOfBeds > 1 || beds.length != stepForm.numberOfBeds)  && (
            <th style={{paddingTop: '20px', paddingBottom: '20px', paddingBottom: '20px', paddingLeft: "6px", paddingRight: '6px'}}>
              <div>
              {(beds.length < stepForm.numberOfBeds && (ind == stepForm.numberOfBeds - 2 || ind == beds.length - 1)) && 
              (
                <button
                  onClick={() => {
                    handleBed(ind)
                  }}
                  type="button"
                  className=" tw-h-12 tw-w-12 tw-bg-[#c8c8c8] tw-rounded-lg tw-outline-none flex-center tw-text-[#343a40] tw-border-none"
                >
                  <BsPlusLg size={20} />
                </button>)
              } 

                {(beds.length >= stepForm.numberOfBeds || (ind != stepForm.numberOfBeds - 2 && ind != beds.length - 1)) &&  <button
                  onClick={() => removeBed(ind)}
                  type="button"
                  className=" tw-h-12 tw-w-12 tw-bg-[#c8c8c8] tw-rounded-lg tw-outline-none tw-text-[#343a40] tw-border-none"
                >
                  <BsTrash size={15} />
                </button>} 
              </div>
            </th>
            )}
          </tr>
        );
    });
  };

  const handleStep = (tag, value) => {
    if (tag === "roomType") {
      setStepForm({ ...stepForm, [tag]: value, numberOfBeds: "" });
      // setBeds([]);
    } else {
      if (tag === "numberOfBeds") {
        if (value) {
          value = Math.floor(parseInt(value));
        }
        // setBeds([]);
      }
      setStepForm({ ...stepForm, [tag]: value });
    }
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    valueRef.current = {
      ...formData,
      sleepingArrangements: roomList,
    }
    setFormData({
      ...formData,
      sleepingArrangements: roomList,
    });

    setBeds([]);
    const emptyProperty = hasEmptyProperty(roomList);
    if (emptyProperty.length > 0) {
      toast.info(emptyProperty[0].error, { toastId: "bed" });
      return;
    }

    const result = validateSleepingArrangements({
      ...formData,
      sleepingArrangements: roomList,
    })

    if(!result.isValid) {
     if(result.errors.length > 0) {
      toast.info(result.errors[0].error, { toastId: "bed" });
     }
      return
    }

    if (roomList.length) {
      setTimeout(() => {
        save({ sleepingArrangements: roomList });
        onNext();
      }, 0); 
    }
  };

  function hasEmptyProperty(roomList = []) {
    let errors = [];
    if (roomList.length === 0) {
      errors.push({ error: "Atleast 1 room is required", errorType: "room" });
    }
    roomList.forEach((room) => {
      if (room.beds.length === 0) {
        errors.push({ error: "Atleast 1 bed is required", errorType: "bed" });
      }
      if (room.beds.length !== room.numberOfBeds) {
        errors.push({ error: "No. of bed must be equal", errorType: "bed" });
      }
      if (formData.rentalType === "Crashpad") {
        room.beds.forEach((bed) => {
          if (bed.bedNumber.trim().length === 0) {
            errors.push({
              error: "Bed Number is required for Room " + room.roomNumber,
              errorType: "bed",
            });
          }
        });
      }
    });

    console.log(errors, "has empty values errors");
    return errors;
  }

  const handleBathroom = ({ type }) => {
    if (type === "minus") {
      if (numberOfBathroom === 0) {
        return;
      } else setBathroom(numberOfBathroom - 0.5);
    } else {
      setBathroom(numberOfBathroom + 0.5);
    }
  };

  useEffect(() => {
    if(stepForm.roomType && stepForm.roomType === 'Private') {
      handleStep("numberOfBeds", 1)
    }
  }, [stepForm.roomType])

  useEffect(() => {
    if(stepForm.numberOfBeds && stepForm.numberOfBeds > 0 && beds.length == 0) {
      setBeds([emptyProperty()])
    }
    if(stepForm.roomType &&  stepForm.roomType == 'Private' && stepForm.numberOfBeds && stepForm.numberOfBeds < beds.length) {
      setBeds(beds.slice(0, stepForm.numberOfBeds))
    }
  }, [stepForm.numberOfBeds])

  return (
    <div className={className}  ref={elementRef}>
      <div className=" tw-min-h-[60vh]">
        <h4 className="mb-5 tw-flex tw-justify-start tw-items-center">
          <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
            7
          </span>{" "}
          Sleeping Arrangements
        </h4>
        <div className=" row col-lg-12">
          <div className="card">
            <div className="card-body">
              {/* <p className="tw-text-sm tw-text-gray-400 tw-my-2">
                  ⓘ Add all rooms and beds where guests sleep including those that
                  are currently occupied
                </p> */}
              <div className="table-responsive custom-h-scroll">
                <CustomHorizontalScrollbar ref={scrollbarRef}>
                <table className="table header-border table-responsive-sm">
                  <thead>
                    <tr>
                      <td className=" tw-text-sm md:tw-text-lg tw-font-medium">
                        Room No.
                      </td>
                      <td className=" tw-text-sm md:tw-text-lg tw-font-medium">
                        Room Name
                      </td>
                      {formData.rentalType === "Crashpad" && (
                        <td className=" tw-text-sm md:tw-text-lg tw-font-medium">
                          Room Type
                        </td>
                      )}
                      {formData.rentalType === "Crashpad" && (
                        <td className=" tw-text-sm md:tw-text-lg tw-font-medium">
                          Gender
                        </td>
                      )}
                      {formData.rentalType === "Crashpad" && (
                        <td className=" tw-text-sm md:tw-text-lg tw-font-medium">
                          Crew Type
                        </td>
                      )}
                      <td className=" tw-text-sm md:tw-text-lg tw-font-medium">
                        No. of Bathrooms{" "}
                      </td>
                      <td className=" tw-text-sm md:tw-text-lg tw-font-medium">
                        No. of Beds{" "}
                      </td>
                      <td className="tw-text-sm md:tw-text-lg tw-font-medium room-action-head">
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {roomList.map((curr, ind) => {
                      return (
                        <tr key={ind}>
                          <td>{curr.roomNumber}</td>
                          <td>{curr.roomName}</td>
                          {formData.rentalType === "Crashpad" && (
                            <td>{curr.roomType}</td>
                          )}
                          {formData.rentalType === "Crashpad" && (
                            <td>{curr.genderType}</td>
                          )}
                          {formData.rentalType === "Crashpad" && (
                            <td>{curr.crewType}</td>
                          )}
                          <td>{curr.numberOfBathroom}</td>
                          <td>{curr.beds.length}</td>
                          <td className="room-action-cell">
                            <button
                              onClick={() => editSleepingArrangement(curr, ind)}
                              type="button"
                              className=" tw-h-12 tw-w-12 tw-bg-[#c8c8c8] tw-rounded-lg tw-outline-none tw-text-[#343a40] tw-border-none"
                            >
                              <BsPencilSquare size={17} />
                            </button>

                            <button
                            disabled={curr.isBooked}
                              onClick={() =>
                                deleteSleepingArrangement(curr, ind)
                              }
                              type="button"
                              className={`mx-1 tw-h-12 tw-w-12 ${curr.isBooked?'tw-bg-[#e0e0e0]':'tw-bg-[#c8c8c8]'} tw-rounded-lg tw-outline-none tw-text-[#343a40] tw-border-none`}
                            >
                              <BsTrash size={17} color={curr.isBooked?'#a4a4a4':''}/>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                <div className="tw-p-5">
                  <h4 className="tw-text-center">
                    {roomList.length > 0
                      ? "Add More Rooms"
                      : "No Room Added yet"}
                  </h4>
                  <button
                    type="button"
                    onClick={() => addSleepingArrangement()}
                    className="tw-mx-auto tw-h-16 tw-w-16 tw-bg-[#c8c8c8] tw-rounded-lg tw-outline-none flex-center tw-text-[#343a40] tw-border-none"
                    // data-bs-toggle="modal"
                    // data-bs-target=".bd-example-modal-lg"
                  >
                    <BsPlusLg size={22} />
                  </button>
                </div>
                </CustomHorizontalScrollbar>
              </div>
              <div
                className="modal  bd-example-modal-lg"
                tabindex="-1"
                role="dialog"
                aria-hidden="true"
                id="addRoomModal"
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Add Room</h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                      ></button>
                    </div>
                    <form onSubmit={handleRoom}>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-lg-6 mb-2">
                            <div className="mb-3">
                              <label className="text-label form-label">
                                Room Number
                              </label>
                              <input
                                disabled={isEdit?roomList?roomList[index].isBooked:false:false}
                                onChange={(e) =>
                                  handleStep("roomNumber", e.target.value)
                                }
                                value={
                                  stepForm["roomNumber"]
                                    ? stepForm["roomNumber"]
                                    : ""
                                }
                                type="text"
                                name="roomNumber"
                                className="form-control"
                                placeholder="Room Number"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 mb-2">
                            <div className="mb-3">
                              <label className="text-label form-label">
                                Room Name
                              </label>
                              <input
                              disabled={isEdit?roomList?roomList[index].isBooked:false:false}
                                onChange={(e) =>
                                  handleStep("roomName", e.target.value)
                                }
                                value={
                                  stepForm["roomName"]
                                    ? stepForm["roomName"]
                                    : ""
                                }
                                type="text"
                                name="roomName"
                                className="form-control"
                                placeholder="Room Name"
                                required
                              />
                            </div>
                          </div>

                          {formData.rentalType === "Crashpad" && (
                            <div className="col-lg-6 mb-2">
                              <div className="mb-3">
                                <label className="form-label">Room Type</label>
                                <select
                                  disabled={isEdit?roomList?roomList[index].isBooked:false:false}
                                  onChange={(e) =>
                                    handleStep("roomType", e.target.value)
                                  }
                                  value={
                                    stepForm["roomType"]
                                      ? stepForm["roomType"]
                                      : ""
                                  }
                                  name="roomType"
                                  className="  form-control wide"
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="Shared">Shared</option>
                                  <option value="Private">Private</option>
                                </select>
                              </div>
                            </div>
                          )}
                          {formData.rentalType === "Crashpad" && (
                            <div className="col-lg-6 mb-2">
                              <div className="mb-3">
                                <label className="form-label">
                                  Gender Type
                                </label>
                                <select
                                 disabled={isEdit?roomList?roomList[index].isBooked:false:false}
                                  onChange={(e) =>
                                    handleStep("genderType", e.target.value)
                                  }
                                  value={
                                    stepForm["genderType"]
                                      ? stepForm["genderType"]
                                      : ""
                                  }
                                  className="form-control wide"
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                  <option value="Co-Ed">Co-Ed</option>
                                </select>
                              </div>
                            </div>
                          )}
                          {formData.rentalType === "Crashpad" && (
                            <div className="col-lg-6 mb-2">
                              <div className="mb-3">
                                <label className="form-label"> Crew Type</label>
                                <select
                                 disabled={isEdit?roomList?roomList[index].isBooked:false:false}
                                  onChange={(e) =>
                                    handleStep("crewType", e.target.value)
                                  }
                                  value={
                                    stepForm["crewType"]
                                      ? stepForm["crewType"]
                                      : ""
                                  }
                                  className="form-control wide"
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="Flight Attendant Only">
                                    Flight Attendant Only
                                  </option>
                                  <option value="Pilot Only">Pilot Only</option>
                                  <option value="Flight Attendant & Pilot Only">
                                    Flight Attendant & Pilot Only
                                  </option>
                                  <option value="All Airline Professionals">
                                    All Airline Professionals
                                  </option>
                                </select>
                              </div>
                            </div>
                          )}

                          {formData.rentalType === "Crashpad" && (
                            <div className="col-lg-6 mb-2">
                              <div className="mb-3">
                                <label className="text-label form-label">
                                  Number of Beds
                                </label>
                                <input
                                  onChange={(e) => {
                                    if (
                                      (stepForm["roomType"] === "Shared" &&
                                        parseInt(e.target.value) <= 50 &&
                                        parseInt(e.target.value) >= 1) ||
                                      e.target.value == ""
                                    ) {
                                      handleStep(
                                        "numberOfBeds",
                                        e.target.value
                                      );
                                    } else if (
                                      (stepForm["roomType"] === "Private" &&
                                        parseInt(e.target.value) <= 1 &&
                                        parseInt(e.target.value) >= 1) ||
                                      e.target.value == ""
                                    ) {
                                      handleStep(
                                        "numberOfBeds",
                                        e.target.value
                                      );
                                    }
                                  }}
                                  value={
                                    stepForm["numberOfBeds"]
                                      ? stepForm["numberOfBeds"]
                                      : ""
                                  }
                                  maxLength={2}
                                  min={1}
                                  max={50}
                                  name="bedNumbers"
                                  className="form-control"
                                  placeholder="Number of beds"
                                  required
                                  disabled={!stepForm["roomType"]?!stepForm["roomType"]:isEdit?roomList?roomList[index].isBooked:false:false}
                                  type="text"
                                  pattern="[0-9]*"
                                />
                              </div>
                            </div>
                          )}
                          {formData.rentalType === "Entire Place" && (
                            <div className="col-lg-6 mb-2">
                              <div className="mb-3">
                                <label className="text-label form-label">
                                  Number of Beds
                                </label>
                                <input
                                  disabled={isEdit?roomList?roomList[index].isBooked:false:false}
                                  onChange={(e) => {
                                    if (
                                      parseInt(e.target.value) >= 1 ||
                                      e.target.value == ""
                                    ) {
                                      handleStep(
                                        "numberOfBeds",
                                        e.target.value
                                      );
                                    }
                                  }}
                                  value={
                                    stepForm["numberOfBeds"]
                                      ? stepForm["numberOfBeds"]
                                      : ""
                                  }
                                  min={1}
                                  name="bedNumbers"
                                  className="form-control"
                                  placeholder="Number of beds"
                                  required
                                  type="text"
                                  pattern="[0-9]*"
                                />
                              </div>
                            </div>
                          )}
                          <div className="col-lg-6 mb-2">
                            <div className="mb-3">
                              <label className="text-label form-label">
                                Number of Bathrooms
                              </label>
                              <div className="tw-flex tw-space-x-2 tw-items-center">
                                <span
                                  onClick={() =>{
                                    
                                    const isDisabled = isEdit?roomList?roomList[index].isBooked:false:false;
                                    if(!isDisabled){handleBathroom({ type: "minus" })}
                                  }
                                  }
                                  className="tw-cursor-pointer tw-flex-shrink-0 tw-block tw-h-10 tw-w-10 tw-rounded-full tw-bg-gray-400 tw-border tw-flex tw-items-center tw-justify-center"
                                >
                                  <AiOutlineMinus
                                    size={18}
                                    className="tw-text-gray-700"
                                  />
                                </span>
                                <div className="tw-w-44 tw-flex-grow">
                                  <input
                                    readOnly
                                    value={numberOfBathroom}
                                    type="text"
                                    name="numberOfBathroom"
                                    className="form-control"
                                    placeholder="Number of Bathroom"
                                    required
                                  />
                                </div>
                                <span
                                  onClick={() =>{
                                    const isDisabled = isEdit?roomList?roomList[index].isBooked:false:false;
                                    if(!isDisabled){handleBathroom({ type: "plus" })}
                                  }
                                  }
                                  className="tw-cursor-pointer tw-flex-shrink-0 tw-block tw-h-10 tw-w-10 tw-rounded-full tw-bg-gray-400 tw-border tw-flex tw-items-center tw-justify-center"
                                >
                                  <AiOutlinePlus
                                    size={18}
                                    className="tw-text-gray-700"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-lg-6 mb-2">
                                <div>
                                  <label className="form-label">
                                    {" "}
                                    numberOfBathroom Type
                                  </label>
                                  <select
                                    onChange={(e) =>
                                      handleStep("bathroom_type", e.target.value)
                                    }
                                    value={stepForm["bathroom_type"]}
                                    className=" form-control wide"
                                  >
                                    <option value="">Select</option>
                                    <option value="fully"> Fully</option>
                                    <option value="half">Half</option>
                                    <option value="No numberOfBathroom">
                                      No numberOfBathroom
                                    </option>
                                  </select>
                                </div>
                              </div> */}
                        </div>
                        <h5 className="modal-title tw-my-4">Add Bed</h5>
                        
                        <div className="table-responsive bedTable custom-h-scroll">
                        <CustomHorizontalScrollbar>
                          <table className="table table-responsive-sm">
                            <thead>
                              <tr>
                                {formData.rentalType === "Crashpad" && (
                                  <th className="tw-text-sm md:tw-text-base" style={{width: '5rem', paddingLeft: '6px', paddingRight: '6px'}}>
                                    Bed Number
                                  </th>
                                )}
                                <th className="tw-text-sm md:tw-text-base" style={{paddingLeft: '6px', paddingRight: '6px'}}>
                                  Bed Type
                                </th>
                                {formData.rentalType === "Crashpad" &&
                                  (formData.bookingType === "Hot bed" ||
                                    formData.bookingType === "Flexible") && (
                                    <th className="tw-text-sm md:tw-text-base" style={{paddingLeft: '6px', paddingRight: '6px'}}>
                                      Nightly Price
                                    </th>
                                  )}
                                {formData.rentalType === "Crashpad" &&
                                  (formData.bookingType === "Cold bed" ||
                                    formData.bookingType === "Flexible") && (
                                    <th className="tw-text-sm md:tw-text-base" style={{paddingLeft: '6px', paddingRight: '6px'}}>
                                      Reserve Monthly Price
                                    </th>
                                  )}
                              {stepForm.numberOfBeds > 1 &&
                                <th className="tw-text-sm md:tw-text-base" style={{paddingLeft: '6px', paddingRight: '6px'}}>
                                </th>
                              }
                              </tr>
                            </thead>
                            <tbody>
                              {renderBedlist()}

                              {/* {beds.length < stepForm.numberOfBeds && (
                                <tr>
                                  {formData.rentalType === "Crashpad" && (
                                    <th>
                                      <div>
                                        <input
                                          onChange={(e) => {
                                            setBedNumber(e.target.value);
                                          }}
                                          value={bedNumber}
                                          type="text"
                                          className="form-control"
                                          placeholder="Bed Number"
                                          required
                                        />
                                      </div>
                                    </th>
                                  )}
                                  <th>
                                    <div>
                                      <select
                                        name="bed_type"
                                        onChange={(e) =>
                                          setBedType(e.target.value)
                                        }
                                        value={bedType}
                                        className="form-control wide"
                                        required
                                      >
                                        <option value="">Select</option>
                                        <option value="King">King</option>
                                        <option value="Queen">Queen</option>
                                        <option value="Twin">Twin</option>
                                        <option value="Couch">Couch</option>
                                        <option value="Top bunk">
                                          Top bunk
                                        </option>
                                        <option value="Bottom bunk">
                                          Bottom bunk
                                        </option>
                                        <option value="Other">Other</option>
                                      </select>
                                    </div>
                                  </th>

                                  {formData.rentalType === "Crashpad" &&
                                    (formData.bookingType === "Hot bed" ||
                                      formData.bookingType === "Flexible") && (
                                      <th>
                                        <div>
                                          <input
                                            onChange={(e) => {
                                              if (
                                                parseInt(e.target.value) >= 1 ||
                                                e.target.value == ""
                                              ) {
                                                setNightPrice(
                                                  e.target.value
                                                    ? Math.floor(
                                                        parseInt(e.target.value)
                                                      )
                                                    : ""
                                                );
                                              }
                                            }}
                                            value={perNightPrice}
                                            placeholder="Per night price"
                                            maxLength={9}
                                            min={1}
                                            max={999999999}
                                            className="form-control"
                                            type="text"
                                            required
                                          />
                                        </div>
                                      </th>
                                    )}
                                  {formData.rentalType === "Crashpad" &&
                                    (formData.bookingType === "Cold bed" ||
                                      formData.bookingType === "Flexible") && (
                                      <th>
                                        <div>
                                          <input
                                            onChange={(e) => {
                                              if (
                                                parseInt(e.target.value) >= 1 ||
                                                e.target.value == ""
                                              ) {
                                                setMonthPrice(
                                                  e.target.value
                                                    ? Math.floor(
                                                        parseInt(e.target.value)
                                                      )
                                                    : ""
                                                );
                                              }
                                            }}
                                            value={perMonthPrice}
                                            type="number"
                                            className="form-control"
                                            placeholder="Per month price"
                                            maxLength={9}
                                            min={1}
                                            max={999999999}
                                            required
                                          />
                                        </div>
                                      </th>
                                    )}
                                {beds.length < ((stepForm.numberOfBeds ?? 0) - 1) &&
                                  <th>
                                    <div>
                                      <button
                                        onClick={handleBed}
                                        type="button"
                                        className=" tw-h-12 tw-w-12 tw-bg-[#c8c8c8] tw-rounded-lg tw-outline-none flex-center tw-text-[#343a40] tw-border-none"
                                      >
                                        <BsPlusLg size={20} />
                                      </button>
                                    </div>
                                  </th>
                                }
                                </tr>
                              )} */}

                              {/* {isEditBed && (
                                      <tr>
                                        {formData.rentalType === "Crashpad" && (
                                          <th>
                                            <div>
                                              <input
                                                onChange={(e) => {
                                                  setBedNumber(e.target.value);
                                                }}
                                                value={bedNumber}
                                                type="text"
                                                className="form-control"
                                                placeholder="Bed Number"
                                                required
                                              />
                                            </div>
                                          </th>
                                        )}
                                        <th>
                                          <div>
                                            <select
                                              name="bed_type"
                                              onChange={(e) =>
                                                setBedType(e.target.value)
                                              }
                                              value={bedType}
                                              className="form-control wide"
                                              required
                                            >
                                              <option value="">Select</option>
                                              <option value="King">King</option>
                                              <option value="Queen">Queen</option>
                                              <option value="Top bunk">
                                                Top bunk
                                              </option>
                                              <option value="Bottom bunk">
                                                Bottom bunk
                                              </option>
                                            </select>
                                          </div>
                                        </th>
  
                                        {formData.rentalType === "Crashpad" &&
                                          (formData.bookingType === "Hot bed" ||
                                            formData.bookingType ===
                                            "Flexible") && (
                                            <th>
                                              <div>
                                                <input
                                                  onChange={(e) => {
                                                    if (
                                                      parseInt(e.target.value) >=
                                                      1 ||
                                                      e.target.value == ""
                                                    ) {
                                                      setNightPrice(
                                                        e.target.value
                                                          ? Math.floor(
                                                            parseInt(
                                                              e.target.value
                                                            )
                                                          )
                                                          : ""
                                                      );
                                                    }
                                                  }}
                                                  value={perNightPrice}
                                                  placeholder="Per night price"
                                                  maxLength={9}
                                                  min={1}
                                                  max={999999999}
                                                  className="form-control"
                                                  type="text"
                                                  required
                                                />
                                              </div>
                                            </th>
                                          )}
                                        {formData.rentalType === "Crashpad" &&
                                          (formData.bookingType === "Cold bed" ||
                                            formData.bookingType ===
                                            "Flexible") && (
                                            <th>
                                              <div>
                                                <input
                                                  onChange={(e) => {
                                                    if (
                                                      parseInt(e.target.value) >=
                                                      1 ||
                                                      e.target.value == ""
                                                    ) {
                                                      setMonthPrice(
                                                        e.target.value
                                                          ? Math.floor(
                                                            parseInt(
                                                              e.target.value
                                                            )
                                                          )
                                                          : ""
                                                      );
                                                    }
                                                  }}
                                                  value={perMonthPrice}
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Per month price"
                                                  maxLength={9}
                                                  min={1}
                                                  max={999999999}
                                                  required
                                                />
                                              </div>
                                            </th>
                                          )}
  
                                        <th>
                                          <div>
                                            <button
                                              onClick={updatedBed}
                                              type="button"
                                              className=" tw-h-12 tw-w-12 tw-bg-[#c8c8c8] tw-rounded-lg tw-outline-none flex-center tw-text-[#343a40] tw-border-none"
                                            >
                                              <BsCheck2All size={20} />
                                            </button>
                                          </div>
                                        </th>
                                      </tr>
                                    )} */}
                            </tbody>
                          </table>
                          </CustomHorizontalScrollbar>
                        </div>
                       
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-danger light"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-secondary">
                          Save changes
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <button
          onClick={onPrev}
          type="button"
          className="btn btn-secondary mx-2 tw-mb-2"
        >
          Prev
        </button>

        <button
          disabled={updating}
          onClick={handleNextStep}
          className="btn btn-secondary tw-mb-2"
        >
          {updating ? "Updating ..." : "Save & Next"}
        </button>
      </div>
    </div>
  );
};
